import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Loader2 } from "lucide-react";
import AppShell from "@/components/AppShell";
import PatientForm, { initialPatient } from "@/components/PatientForm";
import api, { formatApiError } from "@/lib/api";

export default function PatientEdit() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [f, setF] = useState(initialPatient);
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [error, setError] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get(`/patients/${id}`);
                setF({ ...initialPatient, ...data });
            } catch (err) {
                if (err?.response?.status === 404) setNotFound(true);
                else toast.error(formatApiError(err));
            } finally { setFetching(false); }
        })();
    }, [id]);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true); setError(null);
        try {
            await api.put(`/patients/${id}`, f);
            toast.success("Dados do paciente atualizados.");
            navigate(`/patients/${id}`);
        } catch (err) { setError(formatApiError(err)); }
        finally { setLoading(false); }
    };

    if (fetching) return <AppShell><div className="flex justify-center py-24"><Loader2 className="animate-spin text-brand" size={32} /></div></AppShell>;
    if (notFound) return <AppShell><p className="text-muted-clinical">Paciente não encontrado.</p></AppShell>;

    return (
        <AppShell>
            <button data-testid="patient-edit-back" onClick={() => navigate(-1)} className="btn-ghost mb-4"><ArrowLeft size={16} /> Voltar</button>
            <div className="max-w-3xl">
                <h1 className="font-display text-3xl font-medium text-brand mb-1">Editar paciente</h1>
                <p className="text-muted-clinical mb-6">Atualize dados demográficos, contato, cuidador e observações.</p>
                <PatientForm
                    value={f}
                    onChange={setF}
                    onSubmit={submit}
                    loading={loading}
                    error={error}
                    submitLabel="Salvar alterações"
                />
            </div>
        </AppShell>
    );
}
